module.exports = __webpack_public_path__ + "media/packs/images/flags/SD-7439301672f12ae36cef1a8e7449e602.svg";